/* eslint-disable */
import React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { Px } from '../assets/posize';
import HeaderBlack from '../components/HeaderBlack';

export default function SOUL4(props) {
  return (
    <div
      style={{
        '--src': `url(${
          require('assets/72ab1d98b65785804fb4fb755ac21e78.jpeg').default
        })`
      }}
      className={`s-ou-l4 ${css(styles.group, styles.group_layout)}`}
    >
      <div className={css(styles.flex, styles.flex_layout1)}>
        <div className={css(styles.flex_item)}>
          <div className={css(styles.component, styles.component_layout)}>
            <HeaderBlack
              icon={
                require('assets/d322d14b233070bbff024a1a56d1eb66.png').default
              }
              image={
                require('assets/c6b10e4947e78c4196251481415c35c3.png').default
              }
            />
          </div>
        </div>
        <div className={css(styles.flex_item1)}>
          <div className={css(styles.cover_group, styles.cover_group_layout)}>
            <div
              style={{
                '--src': `url(${
                  require('assets/8154ce990188fdb5f3a8c9be75b94491.png').default
                })`
              }}
              className={css(styles.group1, styles.group1_layout)}
            >
              <div
                style={{
                  '--src': `url(${
                    require('assets/8d1fa4730bf0b8ff9ca40936ab9a139f.png')
                      .default
                  })`
                }}
                className={css(styles.image, styles.image_layout)}
              />
            </div>
          </div>
        </div>
        <h4 className={css(styles.highlights, styles.highlights_layout)}>
          {'你/妳的靈魂是'}
        </h4>
        <h1 className={css(styles.big_title, styles.big_title_layout)}>
          {'散發魅力的鬼靈精'}
        </h1>
        <div className={css(styles.flex_item2)}>
          <h5 className={css(styles.highlights1, styles.highlights1_layout)}>
            {
              '你自有姿態，卻也值得頌讚。你的獨特性格與魅力，就像是小王子故事中的玫瑰花。玫瑰花說：「我是與太陽同時出生的。」與生俱來的自戀與自信，活潑聰穎、獨樹一格。'
            }
          </h5>
        </div>
        <div className={css(styles.flex_item3)}>
          <div
            onClick={() => window.open('/soul', '_self')}
            className={`${css(
              styles.group2,
              styles.group2_layout
            )} cursor-pointer to-more`}
          >
            <h5 className={css(styles.highlights2, styles.highlights2_layout)}>
              {'五感靈魂樣貌'}
            </h5>
          </div>
        </div>
        <div className={css(styles.flex_item4)}>
          <div
            style={{
              '--src': `url(${
                require('assets/a47a87bd6e7ede16ab9bf8d263c1efd9.png').default
              })`
            }}
            className={css(styles.image1, styles.image1_layout)}
          />
        </div>
        <h4 className={css(styles.highlights3, styles.highlights3_layout)}>
          {'專屬於你的風味想像'}
        </h4>
        <div className={css(styles.flex_item5)}>
          <div
            className={css(styles.paragraph_body, styles.paragraph_body_layout)}
          >
            {
              '在百花園裡，破曉的雨露欲滴，散發花果的清淡酸甜。誰說芳香必然親人？當冷清為彼此之間拉出了距離，一切感知就變得更為幽微，也更令人癡狂。'
            }
          </div>
        </div>
        <div className={css(styles.flex_item6)}>
          <h4 className={css(styles.highlights4, styles.highlights4_layout)}>
            {'推薦給你：果樹下的茶・冰釀果香有機紅烏龍'}
          </h4>
        </div>
        <div className={css(styles.flex_item7)}>
          <div
            className={css(
              styles.paragraph_body,
              styles.paragraph_body_layout1
            )}
          >
            {
              '本是一款富有華麗果香的紅烏龍，冷泡手法讓風味更為凝縮，也產生端莊與孤挺的氣息。留出空間，讓你自己與味覺對話。'
            }
          </div>
        </div>
        <div className={css(styles.flex_item8)}>
          <div className={css(styles.flex1, styles.flex1_layout)}>
            <div className={css(styles.flex_item9)}>
              <div
                className={css(styles.cover_group1, styles.cover_group1_layout)}
              >
                <div
                  className={css(
                    styles.small_text_body,
                    styles.small_text_body_layout
                  )}
                >
                  {'風味標籤'}
                </div>
              </div>
            </div>
            <div className={css(styles.flex_spacer)} />
            <div className={css(styles.flex_item10)}>
              <div
                className={css(
                  styles.small_paragraph_body,
                  styles.small_paragraph_body_layout
                )}
              >
                {
                  '焦糖、南島暖陽、山徑小黃花、輕土香、溫和的中式糕點、熱帶闊葉林'
                }
              </div>
            </div>
          </div>
        </div>
        <div className={css(styles.flex_item11)}>
          <div className={css(styles.flex2, styles.flex2_layout)}>
            <div className={css(styles.flex_item12)}>
              <div
                className={css(styles.cover_group2, styles.cover_group2_layout)}
              >
                <div
                  className={css(
                    styles.small_text_body,
                    styles.small_text_body_layout1
                  )}
                >
                  {'茶體'}
                </div>
              </div>
            </div>
            <div className={css(styles.flex_spacer)} />
            <div
              className={css(
                styles.small_text_body1,
                styles.small_text_body1_layout
              )}
            >
              {'輕盈'}
            </div>
            <div className={css(styles.flex_spacer1)} />
            <div className={css(styles.flex_item13)}>
              <div className={css(styles.flex3, styles.flex3_layout)}>
                <div
                  style={{
                    '--src': `url(${
                      require('assets/6dbfb4f5ef2cfe6162a8879d5a969507.svg')
                        .default
                    })`
                  }}
                  className={css(styles.image, styles.image_layout1)}
                />
                <div className={css(styles.flex_item14)}>
                  <div className={css(styles.group3, styles.group3_layout)}>
                    <div
                      style={{
                        '--src': `url(${
                          require('assets/921efc0e583a03250580870e2c8c1a78.svg')
                            .default
                        })`
                      }}
                      className={css(styles.image, styles.image_layout2)}
                    />
                  </div>
                </div>
                <div className={css(styles.flex_item15)}>
                  <div className={css(styles.group4, styles.group4_layout)}>
                    <div
                      style={{
                        '--src': `url(${
                          require('assets/7d5da5b56d2a9a132881c8c72e0afce4.svg')
                            .default
                        })`
                      }}
                      className={css(styles.image, styles.image_layout3)}
                    />
                  </div>
                </div>
                <div className={css(styles.flex_item16)}>
                  <div className={css(styles.group5, styles.group5_layout)}>
                    <div
                      style={{
                        '--src': `url(${
                          require('assets/d56d4fe1215e7d557116989e79fa4c8a.svg')
                            .default
                        })`
                      }}
                      className={css(styles.image, styles.image_layout4)}
                    />
                  </div>
                </div>
                <div className={css(styles.flex_item17)}>
                  <div className={css(styles.group6, styles.group6_layout)}>
                    <div
                      style={{
                        '--src': `url(${
                          require('assets/3403a5d674fa3512bf6098d7dca93bff.svg')
                            .default
                        })`
                      }}
                      className={css(styles.image, styles.image_layout5)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={css(styles.flex_item18)}>
          <div className={css(styles.flex4, styles.flex4_layout)}>
            <div className={css(styles.flex_item19)}>
              <div
                className={css(styles.cover_group3, styles.cover_group3_layout)}
              >
                <div
                  className={css(
                    styles.small_text_body,
                    styles.small_text_body_layout2
                  )}
                >
                  {'泡法'}
                </div>
              </div>
            </div>
            <div className={css(styles.flex_spacer)} />
            <div className={css(styles.flex_item20)}>
              <div className={css(styles.flex, styles.flex_layout)}>
                <div className={css(styles.flex_item21)}>
                  <div className={css(styles.flex5, styles.flex5_layout)}>
                    <div className={css(styles.flex_item22)}>
                      <div
                        style={{
                          '--src': `url(${
                            require('assets/215e907768758e1ab50b8b2a3fa739c8.png')
                              .default
                          })`
                        }}
                        className={css(styles.image, styles.image_layout6)}
                      />
                    </div>
                    <div className={css(styles.flex_spacer2)} />
                    <div
                      className={css(
                        styles.small_text_body2_box,
                        styles.small_text_body2_box_layout
                      )}
                    >
                      <div className={css(styles.small_text_body2)}>
                        <span className={css(styles.small_text_body2_span0)}>
                          {'600ml'}
                        </span>
                        <span className={css(styles.small_text_body2_span1)}>
                          {' 冷萃'}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  className={css(
                    styles.small_text_body3_box,
                    styles.small_text_body3_box_layout
                  )}
                >
                  <div className={css(styles.small_text_body3)}>
                    <span className={css(styles.small_text_body3_span0)}>
                      {'茶葉 '}
                    </span>
                    <span className={css(styles.small_text_body3_span1)}>
                      {'6g'}
                    </span>
                    <span className={css(styles.small_text_body3_span2)}>
                      {' / 茶包'}
                    </span>
                    <span className={css(styles.small_text_body3_span3)}>
                      {'2'}
                    </span>
                    <span className={css(styles.small_text_body3_span4)}>
                      {'個'}
                    </span>
                  </div>
                </div>
                <div
                  className={css(
                    styles.small_text_body4,
                    styles.small_text_body4_layout
                  )}
                >
                  {'水溫：常溫'}
                </div>
                <div
                  className={css(
                    styles.small_text_body5_box,
                    styles.small_text_body5_box_layout
                  )}
                >
                  <div className={css(styles.small_text_body5)}>
                    <span className={css(styles.small_text_body5_span0)}>
                      {'時間：放冰箱'}
                    </span>
                    <span className={css(styles.small_text_body5_span1)}>
                      {'24'}
                    </span>
                    <span className={css(styles.small_text_body5_span2)}>
                      {'小時，搖勻後飲用'}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={css(styles.flex_item23)}>
          <div
            onClick={() =>
              window.open(
                'https://www.daughter-tea.com/product.aspx?openExternalBrowser=1&Id=7'
              )
            }
            className={`${css(
              styles.group7,
              styles.group7_layout
            )} cursor-pointer to-more`}
          >
            <h5 className={css(styles.highlights5, styles.highlights5_layout)}>
              {'了解更多'}
            </h5>
          </div>
        </div>
        <div className={css(styles.flex_item24)}>
          <div
            onClick={() => window.open('/', '_self')}
            className={`${css(
              styles.group8,
              styles.group8_layout
            )} cursor-pointer to-home`}
          >
            <div className={css(styles.background, styles.background_layout)} />
            <h5 className={css(styles.highlights6, styles.highlights6_layout)}>
              {'重新探索'}
            </h5>
          </div>
        </div>
      </div>
    </div>
  );
}

SOUL4.inStorybook = true;

const styles = StyleSheet.create({
  group: {
    display: 'flex',
    background: 'var(--src) center center / cover no-repeat',
    backgroundColor: 'rgb(255,255,255)',
    borderRadius: '0px 0px 0px 0px'
  },
  group_layout: {
    position: 'relative',
    minHeight: 1643,
    flexGrow: 1
  },
  flex: {
    display: 'flex',
    flexDirection: 'column'
  },
  flex_layout1: {
    position: 'relative',
    width: 353,
    minWidth: 353,
    margin: '34px auto 53px'
  },
  flex_item: {
    display: 'flex',
    position: 'relative',
    flex: '0 1 49px',
    minHeight: 0
  },
  component: {},
  component_layout: {
    flexGrow: 1,
    margin: '20px 10px 0px 0px'
  },
  flex_item1: {
    display: 'flex',
    position: 'relative',
    flex: '0 1 297px',
    minHeight: 0
  },
  cover_group: {
    display: 'flex',
    backgroundColor: 'rgb(255,255,255)',
    borderRadius: '0px 0px 0px 0px'
  },
  cover_group_layout: {
    position: 'relative',
    flexGrow: 1,
    margin: '40px 10px 0px 0px'
  },
  group1: {
    display: 'flex',
    background: 'var(--src) center center / contain no-repeat',
    borderRadius: '0px 0px 0px 0px'
  },
  group1_layout: {
    position: 'relative',
    flexGrow: 1
  },
  image: {
    background: 'var(--src) center center / contain no-repeat'
  },
  image_layout: {
    height: 90,
    width: 53,
    minWidth: 53,
    margin: '95px 62px 72px auto'
  },
  highlights: {
    display: 'flex',
    alignItems: 'center',
    font: '18px/1.79 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px',
    opacity: 0.69
  },
  highlights_layout: {
    flex: '0 0 auto',
    margin: '15px 0px 0px'
  },
  big_title: {
    display: 'flex',
    alignItems: 'center',
    font: '500 30px/1.8 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  big_title_layout: {
    flex: '0 0 auto',
    margin: '14px 0px 0px'
  },
  flex_item2: {
    display: 'flex',
    position: 'relative',
    flex: '0 1 140px',
    minHeight: 0
  },
  highlights1: {
    font: '16px/1.75 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  highlights1_layout: {
    flexGrow: 1,
    margin: '28px 2px 0px 0px'
  },
  flex_item3: {
    display: 'flex',
    position: 'relative',
    flex: '0 1 54px',
    minHeight: 0
  },
  group2: {
    display: 'flex',
    backgroundColor: 'rgb(94,117,111)',
    borderRadius: '0px 0px 0px 0px'
  },
  group2_layout: {
    position: 'relative',
    minHeight: 44,
    flexGrow: 1,
    margin: '10px 10px 0px 0px'
  },
  highlights2: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    font: '500 16px/1.75 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    textAlign: 'center',
    letterSpacing: '0px'
  },
  highlights2_layout: {
    flexGrow: 1,
    margin: '8px 0px'
  },
  flex_item4: {
    display: 'flex',
    position: 'relative',
    flex: '0 1 302px',
    minHeight: 0
  },
  image1: {
    background: 'var(--src) center center / contain no-repeat',
    borderRadius: '0px 0px 0px 0px'
  },
  image1_layout: {
    height: 257,
    flexGrow: 1,
    margin: '45px 7px 0px 2px'
  },
  highlights3: {
    display: 'flex',
    alignItems: 'center',
    font: '500 18px/1.55 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  highlights3_layout: {
    flex: '0 0 auto',
    margin: '19.5px 0px 0px'
  },
  flex_item5: {
    display: 'flex',
    position: 'relative',
    flex: '0 1 115.5px',
    minHeight: 0
  },
  paragraph_body: {
    font: '14px/1.57 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  paragraph_body_layout: {
    flexGrow: 1,
    margin: '5.5px 2px 0px 0px'
  },
  flex_item6: {
    display: 'flex',
    position: 'relative',
    flex: '0 1 101px',
    minHeight: 0
  },
  highlights4: {
    display: 'flex',
    alignItems: 'center',
    font: '500 18px/1.55 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  highlights4_layout: {
    flexGrow: 1,
    margin: '45px 0px 0px'
  },
  flex_item7: {
    display: 'flex',
    position: 'relative',
    flex: '0 1 81px',
    minHeight: 0
  },
  paragraph_body_layout1: {
    flexGrow: 1,
    margin: '15px 2px 0px 0px'
  },
  flex_item8: {
    display: 'flex',
    position: 'relative',
    flex: '0 1 56px',
    minHeight: 0
  },
  flex1: {
    display: 'flex'
  },
  flex1_layout: {
    position: 'relative',
    flexGrow: 1
  },
  flex_item9: {
    display: 'flex',
    position: 'relative',
    flex: '0 0 auto',
    minWidth: 59
  },
  cover_group1: {
    display: 'flex',
    backgroundColor: 'rgb(130,169,189)',
    borderRadius: '0px 0px 0px 0px'
  },
  cover_group1_layout: {
    position: 'relative',
    minHeight: 20,
    flexGrow: 1,
    margin: '17px 0px 19px'
  },
  small_text_body: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    textAlign: 'center',
    letterSpacing: '0px'
  },
  small_text_body_layout: {
    flexGrow: 1,
    margin: '0px 2px'
  },
  flex_spacer: {
    flex: '0 0 auto',
    minWidth: 8
  },
  flex_item10: {
    display: 'flex',
    position: 'relative',
    flex: '1 1 286px'
  },
  small_paragraph_body: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_paragraph_body_layout: {
    flexGrow: 1,
    margin: '16px 4px 0px 0px'
  },
  flex_item11: {
    display: 'flex',
    position: 'relative',
    flex: '0 1 30px',
    minHeight: 0
  },
  flex2: {
    display: 'flex'
  },
  flex2_layout: {
    position: 'relative',
    flexGrow: 1
  },
  flex_item12: {
    display: 'flex',
    position: 'relative',
    flex: '0 1 59px'
  },
  cover_group2: {
    display: 'flex',
    backgroundColor: 'rgb(130,169,189)',
    borderRadius: '0px 0px 0px 0px'
  },
  cover_group2_layout: {
    position: 'relative',
    minHeight: 20,
    flexGrow: 1,
    margin: '10px 0px 0px'
  },
  small_text_body_layout1: {
    flexGrow: 1,
    margin: '0px 14px'
  },
  small_text_body1: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body1_layout: {
    margin: '10px 0px 0px'
  },
  flex_spacer1: {
    flex: '0 0 auto',
    minWidth: 6
  },
  flex_item13: {
    display: 'flex',
    position: 'relative',
    flex: '0 1 253px'
  },
  flex3: {
    display: 'flex'
  },
  flex3_layout: {
    position: 'relative',
    flexGrow: 1,
    margin: '11px 0px 1px'
  },
  image_layout1: {
    flex: '0 1 13px',
    height: 12,
    width: 13,
    minWidth: 13,
    margin: '3px 0px'
  },
  flex_item14: {
    display: 'flex',
    position: 'relative',
    flex: '0 1 14px'
  },
  group3: {
    display: 'flex',
    opacity: 0.2
  },
  group3_layout: {
    position: 'relative',
    flexGrow: 1
  },
  image_layout2: {
    height: 12,
    width: 13,
    minWidth: 13,
    margin: '3px 0px 3px 1px'
  },
  flex_item15: {
    display: 'flex',
    position: 'relative',
    flex: '0 1 14px'
  },
  group4: {
    display: 'flex',
    opacity: 0.2
  },
  group4_layout: {
    position: 'relative',
    flexGrow: 1
  },
  image_layout3: {
    height: 12,
    width: 13,
    minWidth: 13,
    margin: '3px 0px 3px 1px'
  },
  flex_item16: {
    display: 'flex',
    position: 'relative',
    flex: '0 1 14px'
  },
  group5: {
    display: 'flex',
    opacity: 0.2
  },
  group5_layout: {
    position: 'relative',
    flexGrow: 1
  },
  image_layout4: {
    height: 12,
    width: 13,
    minWidth: 13,
    margin: '3px 0px 3px 1px'
  },
  flex_item17: {
    display: 'flex',
    position: 'relative',
    flex: '0 1 198px'
  },
  group6: {
    display: 'flex',
    opacity: 0.2
  },
  group6_layout: {
    position: 'relative',
    flexGrow: 1,
    margin: '0px 184px 0px 0px'
  },
  image_layout5: {
    height: 12,
    width: 13,
    minWidth: 13,
    margin: '3px 0px 3px 1px'
  },
  flex_item18: {
    display: 'flex',
    position: 'relative',
    flex: '0 1 90px',
    minHeight: 0
  },
  flex4: {
    display: 'flex'
  },
  flex4_layout: {
    position: 'relative',
    flexGrow: 1
  },
  flex_item19: {
    display: 'flex',
    position: 'relative',
    flex: '0 1 59px'
  },
  cover_group3: {
    display: 'flex',
    backgroundColor: 'rgb(130,169,189)',
    borderRadius: '0px 0px 0px 0px'
  },
  cover_group3_layout: {
    position: 'relative',
    minHeight: 20,
    flexGrow: 1,
    margin: '10px 0px 66px'
  },
  small_text_body_layout2: {
    flexGrow: 1,
    margin: '0px 14px'
  },
  flex_item20: {
    display: 'flex',
    position: 'relative',
    flex: '0 1 286px'
  },
  flex_layout: {
    position: 'relative',
    flexGrow: 1,
    margin: '10px 28px 0px 0px'
  },
  flex_item21: {
    display: 'flex',
    position: 'relative',
    flex: '0 1 20px',
    minHeight: 0
  },
  flex5: {
    display: 'flex'
  },
  flex5_layout: {
    position: 'relative',
    flexGrow: 1
  },
  flex_item22: {
    display: 'flex',
    position: 'relative',
    flex: '0 1 14px'
  },
  image_layout6: {
    height: 18,
    width: 9,
    minWidth: 9,
    margin: '2px 0px 0px auto'
  },
  flex_spacer2: {
    flex: '0 0 auto',
    minWidth: 9
  },
  small_text_body2: {
    font: '12px/1.66 "Roboto", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body2_box: {},
  small_text_body2_box_layout: {
    flex: '1 1 auto'
  },
  small_text_body2_span0: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body2_span1: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body3: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body3_box: {},
  small_text_body3_box_layout: {
    flex: '1 0 auto'
  },
  small_text_body3_span0: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body3_span1: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body3_span2: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body3_span3: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body3_span4: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body4: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body4_layout: {
    flex: '1 0 auto'
  },
  small_text_body5: {
    font: '12px/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(17,17,17)',
    letterSpacing: '0px'
  },
  small_text_body5_box: {},
  small_text_body5_box_layout: {
    flex: '0 0 auto'
  },
  small_text_body5_span0: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body5_span1: {
    font: '1em/1.66 "Roboto", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  small_text_body5_span2: {
    font: '1em/1.66 "Noto Sans TC", Helvetica, Arial, serif',
    color: '#111111ff',
    letterSpacing: '0px'
  },
  flex_item23: {
    display: 'flex',
    position: 'relative',
    flex: '0 1 56px',
    minHeight: 0
  },
  group7: {
    display: 'flex',
    backgroundColor: 'rgb(94,117,111)',
    borderRadius: '0px 0px 0px 0px'
  },
  group7_layout: {
    position: 'relative',
    minHeight: 44,
    flexGrow: 1,
    margin: '12px 0px 0px'
  },
  highlights5: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    font: '500 16px/1.75 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(255,255,255)',
    textAlign: 'center',
    letterSpacing: '0px'
  },
  highlights5_layout: {
    flexGrow: 1,
    margin: '8px 0px'
  },
  flex_item24: {
    display: 'flex',
    position: 'relative',
    flex: '0 1 60px',
    minHeight: 0
  },
  group8: {
    display: 'flex'
  },
  group8_layout: {
    position: 'relative',
    minHeight: 44,
    flexGrow: 1,
    margin: '16px 0px 0px'
  },
  background: {
    border: '1px solid rgb(94,117,111)',
    borderRadius: '0px 0px 0px 0px'
  },
  background_layout: {
    position: 'absolute',
    height: 44,
    flexGrow: 1,
    inset: '0px 0px auto'
  },
  highlights6: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    font: '500 16px/1.75 "Noto Sans TC", Helvetica, Arial, serif',
    color: 'rgb(94,117,111)',
    textAlign: 'center',
    letterSpacing: '0px'
  },
  highlights6_layout: {
    flexGrow: 1,
    margin: '8px 0px'
  }
});
